import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcToLocalDate',
    standalone: true,
})
// UTC to Local time conversion, Format as "DD MMM, YYYY" (e.g., "11 Dec, 2025")
export class UtcToLocalDatePipe implements PipeTransform {
    private readonly months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    transform(value: string | null | undefined): string {
        if (!value) return '';

        const utcString = value.endsWith('Z') ? value : `${value}Z`;
        const utcDate = new Date(utcString);

        if (isNaN(utcDate.getTime())) {
            return value;
        }

        const day = utcDate.getDate();
        const month = this.months[utcDate.getMonth()];
        const year = utcDate.getFullYear();

        return `${day} ${month}, ${year}`;
    }
}
